import { BlockDefinition } from '../../types'
import TitleBlock from './TitleBlock'

const titleBlock: BlockDefinition<'title'> = {
  type: 'title',
  createDefaultProps: () => ({
    title: 'Untitled page',
    subtitle: 'A World 50 Cohort'
  }),
  Component: TitleBlock
}

export default titleBlock
